import type { DoorColourName, DoorTypeId, MeasurementMode } from '@planner/config';
import type { LockSide } from '@planner/shared/doors';

export const steps = ['type', 'measure', 'lock', 'colour', 'review'] as const;
export type Step = (typeof steps)[number];
export const numericFields = [
  'width_top',
  'width_middle',
  'width_bottom',
  'height_left',
  'height_right',
  'door_width',
  'door_height',
  'depth',
  'handle_height',
  'quantity',
] as const;
export type NumericField = (typeof numericFields)[number];
export const acknowledgementFields = [
  'width_acknowledgement',
  'height_acknowledgement',
  'depth_acknowledgement',
] as const;
export type AcknowledgementField = (typeof acknowledgementFields)[number];
type ConfigurationChange =
  | { field: 'door_type'; value: DoorTypeId }
  | { field: 'measurement_mode'; value: MeasurementMode }
  | { field: 'lock_side'; value: LockSide }
  | { field: 'frame_colour'; value: DoorColourName }
  | { field: NumericField | AcknowledgementField; value?: never };
export const helpTopics = [
  'measurement_diy',
  'measurement_trade',
  'depth_clearance',
  'handle_height',
  'lock_layout',
  'handing_left',
  'handing_right',
] as const;
export type HelpTopic = (typeof helpTopics)[number];
type Reference = { design_reference: string };
export type CartProperties = Reference & { line_count: number; total: number };
export interface Events {
  planner_started: Record<string, never>;
  planner_step_completed: { step: Step };
  configuration_changed: ConfigurationChange;
  measuring_guide_downloaded: { mode: MeasurementMode };
  help_opened: { topic: HelpTopic };
  error_occurred:
    | { context: 'catalogue_load'; message: 'Catalogue could not be loaded' }
    | { context: 'draft_recovered'; message: 'Saved draft was repaired' }
    | { context: 'draft_discarded'; message: 'Saved draft was discarded' };
  cart_line_added: CartProperties & {
    door_type: DoorTypeId;
    frame_colour: DoorColourName;
    measure_mode: MeasurementMode;
    quantity: number;
    line_total: number;
  };
  cart_line_updated: CartProperties;
  cart_line_removed: CartProperties;
  cart_cleared: CartProperties;
  drawing_approved: { design_reference?: string };
  terms_agreed: Reference;
  privacy_acknowledged: Reference;
  drawing_downloaded: Reference;
  cart_summary_downloaded: CartProperties;
  cart_emailed: Reference;
  checkout_clicked: { channel: 'retail' | 'trade' };
}
